import React from 'react';
import clsx from 'clsx';
import whoopLoading from '../../assets/whoop-loading.gif';
import darkModeLoading from '../../assets/whoop-loading-dark-mode.gif';
import styles from './loading.module.scss';

export type LoadingVariants = 'primary' | 'dark';
export type LoadingSizeType = 'small' | 'medium' | 'large';
const variantToLogo = {
  primary: whoopLoading,
  dark: darkModeLoading,
};
export interface LoadingProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: LoadingSizeType;
  variant?: LoadingVariants;
}

export function Loading({
  size = 'medium',
  className,
  variant = 'primary',
  ...props
}: LoadingProps): JSX.Element {
  return (
    <img
      alt='Loading'
      className={clsx(
        styles.loadingLogo,
        styles[`loadingLogo-${size}`],
        className,
      )}
      data-testid='loading-indicator'
      src={variantToLogo[variant].src}
      {...props}
    />
  );
}
